import classNames from 'classnames';
import { useFormApi } from 'informed';
import { ComponentProps, ReactNode } from 'react';

import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';

type AvailableSpaceOwnProps = {
  valueTotal: ReactNode;
  valueUnfilled: ReactNode;
  onPlus: () => Promise<void> | (() => void);
  onMinus: () => Promise<void> | (() => void);
  disabled?: boolean;
};
type AvailableSpaceProps = AvailableSpaceOwnProps &
  Omit<ComponentProps<'div'>, keyof AvailableSpaceOwnProps>;

const AvailableSpace = ({
  valueTotal,
  valueUnfilled,
  onPlus,
  onMinus,
  disabled,
  className = '',
  ...rest
}: AvailableSpaceProps) => {
  const formApi = useFormApi();
  return (
    <div
      className={classNames(
        'p-4 rounded-xl border border-secondary-100 flex gap-4',
        className
      )}
      {...rest}
    >
      <div className="w-full">
        <p className="text-body-2-xl font-medium mb-3">Celkem brigádníků</p>
        <div className="h-10 flex items-center justify-between border border-secondary-300 rounded-lg px-1 py-1.5">
          <button
            type="button"
            className="p-0"
            disabled={disabled}
            onClick={async () => {
              await onMinus();
              formApi.reset();
            }}
            aria-label="minus button"
          >
            <ActionIcon
              name="minimize"
              className="size-8 p-1 text-secondary-400 bg-secondary-50 rounded-md"
            />
          </button>
          <div className="text-body-2-xl font-medium">{valueTotal}</div>
          <button
            type="button"
            className="p-0"
            disabled={disabled}
            onClick={async () => {
              await onPlus();
              formApi.reset();
            }}
            aria-label="plus button"
          >
            <FavouriteIcon
              name="add"
              className="size-8 p-1 text-secondary-400 bg-secondary-50 rounded-md"
            />
          </button>
        </div>
      </div>
      <div className="min-w-32">
        <p className="text-body-2-xl font-medium mb-3">Volných míst</p>
        <div className="h-10 text-body-2-xl text-secondary-300 flex items-center justify-between border border-secondary-200 rounded-lg pl-3">
          {valueUnfilled}
        </div>
      </div>
    </div>
  );
};

export default AvailableSpace;
